define([
	"dojo/_base/declare",
	"csi/view/ToolbarPluginToggleButton",
	"csi/reflection"
], function(declare,ToolbarPluginToggleButton,reflection) {

	return declare("Freeze", ToolbarPluginToggleButton, {
		validatePlugin: function(/*Context*/ctx) {
			var config = reflection.getObject("centric://REFLECTION/INSTANCE/SourcingModule/Configuration");		
			return !config.OneShipmentsPerPO || config.AllowSharedShipmentsPerPO;
		}
	});
});